import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const tok = localStorage.getItem("mm_token");
  if (tok) config.headers.Authorization = `Bearer ${tok}`;
  return config;
});

// Suppress noisy dev-overlay errors for expected 401/403 responses
api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response) {
      // tag expected auth errors so caller can ignore them silently
      error.handledByInterceptor = [401, 403].includes(error.response.status);
    }
    return Promise.reject(error);
  }
);

export const fileUrl = (id) => `${API_BASE}/upload/file/${id}`;
